import React from 'react';
import DashboardLayout from '../components/DashboardLayout';
import './SocietyManagement.css';

const SocietyManagement = () => {
  const userDataString = localStorage.getItem('userData');
  const userData = userDataString ? JSON.parse(userDataString) : null;

  return (
    <DashboardLayout>
      <div className="society-management">
        <h1>Society Management</h1>
        <div className="society-details">
          <div className="card">
            <h2>Society Details</h2>
            <div className="detail-group">
              <label>Society Name</label>
              <p>{userData?.society}</p>
            </div>
            <div className="detail-group">
              <label>Location</label>
              <p>123 Main Street, City</p>
            </div>
            <div className="detail-group">
              <label>Total Units</label>
              <p>100</p>
            </div>
            <button className="edit-btn">Edit Society Details</button>
          </div>

          <div className="card">
            <h2>Quick Actions</h2>
            <div className="action-buttons">
              <button>Manage Members</button>
              <button>Send Notice</button>
              <button>View Complaints</button>
              <button>Maintenance Records</button>
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default SocietyManagement; 